import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

let _closeSidebar: (() => void) | null = null;
export function setChatSidebarClose(fn: (() => void) | null) {
    _closeSidebar = fn;
}

export const chatSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.CHAT_SIDEBAR}`,
        popover: {
            title: "Conversation History",
            description:
                "All your past conversations are listed here. Select any conversation to resume it, or create a new one to start fresh.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.CHAT_MAIN}`,
        popover: {
            title: "Våll-e Chat",
            description:
                "Your AI-powered hockey analytics assistant. Ask about player performance, team stats, game strategies — anything hockey-related.",
        },
        onHighlightStarted: () => _closeSidebar?.(),
    },
    {
        element: `#${ONBOARDING_IDS.CHAT_INPUT}`,
        popover: {
            title: "Ask a Question",
            description:
                "Type your question here. Use <b>@</b> to tag specific entities — players, teams, or matches — so Våll-e has the exact context it needs to give you a precise answer.",
        },
    },
];
